export type CouncilStatus =
  | 'PENDING'
  | 'ACTIVE'
  | 'CELEBRATING'
  | 'CELEBRATED'
  | 'CLOSED'
  | 'CANCELED';

export type CouncilAttendanceTypes =
  | 'FACE_TO_FACE'
  | 'ONLINE'
  | 'HYBRID'
  | 'WRITTEN_NO_SESSION';

export type CouncilTypes =
  | 'ORDINARY'
  | 'EXTRAORDINARY'
  | 'UNIVERSAL'
  | 'ORDINARY_EXTRAORDINARY';

export type CouncilParticipantUserType =
  | 'DIRECTOR'
  | 'SECRETARY'
  | 'PRESIDENT'
  | 'DELEGATE';

export type CouncilParticipant = {
  _id?: string;
  image?: string;
  member: string;
  name: string;
  email: string;
  address?: string;
  cif?: string;
  percentage?: number;
  userType: CouncilParticipantUserType;
  assists: boolean;
  isAbsent: boolean;
  isRepresented: boolean;
  representative?: string | null;
  participantPosition?: string;
};

export type CouncilNewParticipant = Omit<
  CouncilParticipant,
  '_id' | 'image' | 'address' | 'cif' | 'percentage'
>;

export type CouncilSignature = {
  sentDate: Date;
  envelopeId: string;
  envelopeSignatureId: string;
};

export enum CouncilSignatureTypes {
  ACT = 'ACT', // eslint-disable-line
  CERTIFICATE = 'CERTIFICATE', // eslint-disable-line
}

export type Council = {
  _id?: string;
  name: string;
  details: string;
  topics: string;
  status: CouncilStatus;
  president: string;
  secretary: string;
  isActive?: boolean;
  date: Date;
  attendanceType: CouncilAttendanceTypes;
  place: string;
  onlineAccess: string;
  digitalVoting: boolean;
  minQuorum: number;
  councilType: CouncilTypes;
  participants: CouncilParticipant[] | CouncilNewParticipant[];
  society: string;
  privateDocuments?: string[];
  publicDocuments?: string[];
  announcementText?: string;
  announcementTemplate?: string | null;
  announcementDocument?: string | null;
  announcementCommunication?: string;
  actTemplate?: string | null;
  actDocument?: string | null;
  actSignature?: CouncilSignature;
  actCertificateTemplate?: string | null;
  actCertificateDocument?: string | null;
  actCertificateSignature?: CouncilSignature;
  retriedAnnouncements?: string[];
  isActDocumentPublic?: boolean;
  isActCertificateDocumentPublic?: boolean;
  lastModifiedDate?: Date;
};

export type CouncilAnnouncementData = {
  time: string;
  councilName: string;
  date: string;
  societyName: string;
  announcement: string;
  place: string;
  onlineAccess: string;
  attendanceType: string;
  councilType: string;
};
